import { alertMessage } from "components/toolkit/initial-state.component";
import { User } from "utils/types/user";
import { hostURL } from "utils/helper/states";

export const longEnUSFormatter = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: false,
});
export const greeting = (firstName: string) => {
    var nowTime = new Date();
    const hour = nowTime.getHours();

    //   console.log(nowTime);
    if (hour >= 20) {
      return `Good Night ${firstName}  , Have a good night rest.`;
    } else if (hour > 17) {
      return `Good Evening ${firstName} , Hope you enjoyed your day?`;
    } else if (hour > 11) {
      return `Good Afternoon ${firstName} , How is your day going?`;
    } else if (hour < 12) {
      return `Good Morning ${firstName} , How was your night?`;
    }
  },
  truncateStr = (str = "", MAX = 20) => {
    const truncatedStr = str.substring(0, MAX);
    return str.length > MAX ? truncatedStr + "..." : truncatedStr;
  };

export const slugify = (str: string) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const makeId = (length = 12) => {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789JKLMNOPQRSTUVWXYZ0123456789JKLMNOPQRSTUVWXYZ0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  classNames = (...classes: any[]) => {
    return classes.filter(Boolean).join(" ");
  };

export type Reviews = Review[];

export interface Review {
  name: string;
  amenities: string;
  rating: string;
  review: string;
  createdAt: string;
  id?: string;
  area_id: string;
  image: string;
}
export type PlaceLocation = {
  id: string;
  name: string;
  tags: string;
  slug: string;
  image: string;
};

export interface ReviewFormData {
  name: string;
  amenities: string;
  rating: string;
  review: string;
  area_id: string;
  createdAt?: string;
}

export enum Language {
  Empty = "*",
}
export enum AnimateType {
  SlideInLeft = "slideInLeft",
  SlideInRight = "slideInRight",
  SlideInTop = "slideInTop",
  SlideInDown = "slideInDown",
  FadeInLeft = "fadeInLeft",
  FadeInRight = "fadeInRight",
  FadeInUp = "fadeInUp",
  FadeInDown = "fadeInDown",
  BounceIn = "bounceIn",
  ZoomIn = "zoomIn",
}

export const animate_animation = (animate: AnimateType) => {
  switch (animate) {
    case AnimateType.FadeInLeft:
      return {
        hidden: { opacity: 0, x: -75 },
        visible: { opacity: 1, x: 0 },
      };
    case AnimateType.FadeInRight:
      return {
        hidden: { opacity: 0, x: 75 },
        visible: { opacity: 1, x: 0 },
      };
    case AnimateType.FadeInDown:
      return {
        hidden: { opacity: 0, y: -75 },
        visible: { opacity: 1, y: 0 },
      };
    case AnimateType.FadeInUp:
      return {
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      };
    default:
      return {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
      };
  }
};
export const truncateEmail = (email = "") => {
    return (
      email.substring(0, 3) +
      "..." +
      email.substring(email.indexOf("@"), email.length)
    );
  },
  stringToArray = (inputString: string): string[] => {
    // Split the input string by commas and trim whitespace from each element
    const array = inputString.split(",").map((item) => item.trim());
    return array;
  },
  extractFirstWords = (inputString: string): string => {
    const words = inputString.trim().split(" ");
    let result = words[0]; // Get the first word
    if (words.length > 1) {
      result += " " + words[1].charAt(0) + "."; // Add the first character of the second word with a period
    }
    return result;
  },
  capitalize = (string: string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  shareLink = (copyText: string, title: string) => {
    const _BASE_URL = hostURL;
    const uri = _BASE_URL + copyText;
    //
    if (navigator.share) {
      navigator
        .share({
          title: title,
          url: uri,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      navigator.clipboard.writeText(uri).then(() => {
        alertMessage("success", "Link Copied");
      });
    }
  },
  arrangeReviewsByCreatedAtDesc = (reviews: Reviews): Reviews => {
    // Convert createdAt strings to Date objects for proper sorting
    const reviewsWithDate = reviews.map((review) => ({
      ...review,
      created_at: new Date(review.createdAt.replace(" at ", " ")),
    }));

    // Sort the array by createdAt in descending order
    reviewsWithDate.sort((a, b) => {
      return (
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    });
    const newReviews = reviewsWithDate.map((review) => {
      const { created_at, ...newData } = review;
      return newData;
    });

    // Return the sorted array
    return newReviews;
  },
  processNumbers = (num: number) => {
    const firstChar = num.toString()[0];
    if (firstChar <= "3") {
      return parseInt(firstChar);
    } else {
      return parseInt("3" + num.toString().slice(1));
    }
  },
  goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
  isValidEmail = (email: string): boolean => {
    // Very basic email validation, you might want to use a more robust validation method
    const emailRegex = /\S+@\S+\.\S+/;
    return emailRegex.test(email);
  };
/**
 * Combines a country code and a phone number into a single string.
 * @param countryCode - The country code, e.g., "+234".
 * @param phoneNumber - The phone number, e.g., "08145445888" or "8145445888".
 * @returns The combined phone number, e.g., "+2348145445888".
 */
export const combinePhoneNumber = (
    countryCode: string,
    phoneNumber: string
  ): string => {
    // Remove any leading zeros from the phone number
    const normalizedPhoneNumber = phoneNumber.replace(/^0+/, "");

    // Combine the country code and the normalized phone number
    return `${countryCode}${normalizedPhoneNumber}`;
  },
  isAProvider = (user: User) => user.businessName != null,
  getDaySuffix = (day: number): string => {
    if (day > 3 && day < 21) return "th"; // Handle 11th, 12th, 13th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  },
  formatDate = (date: Date): string => {
    const day = date.getUTCDate();
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getUTCFullYear();

    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "pm" : "am";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Pad minutes with leading zero

    const daySuffix = getDaySuffix(day);

    return `${day}${daySuffix} of ${month}, ${year} at ${formattedHours}:${formattedMinutes} ${ampm}`;
  };
export const apiRequest = async (uri: string, token?: string) => {
  try {
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    const res = await fetch(uri, {
      headers: token == null ? headers : { ...headers, Authorization: token },
    });
    const data = await res.json();

    if (data.success != null) {
      if (data.success) return await data.data;
    }
  } catch (error) {
    console.error(error as Error);
  }
};
